import TaskStatusMenu from "./TaskStatusMenu";
import $ from "jquery";
import WorkflowStatusSelector from "../../workflowStatus/components/WorkflowStatusSelector";
import {WorkflowStatusType} from "../../workflowStatus/constants";

export default class CompletedTaskStatusMenu extends TaskStatusMenu {

    afterRender() {
        this.statusesSelector = new WorkflowStatusSelector({
            typeFilter: WorkflowStatusType.COMPLETED,
            onSelectStatus: (id) => {
                this._selectStatus(id)
            },
            groupByStatusType: false
        }).init(this.$el)

        this.getEl().on('click', e => e.stopPropagation())
    }
}



// WEBPACK FOOTER //
// ./web/js/controls/task/CompletedTaskStatusMenu.js